import { JSX, ParentComponent } from "solid-js";

export const IconGlow: ParentComponent<{
  icon: JSX.Element;
  glowColor: "primary" | "secondary" | "success" | "error" | "warning" | "info";
  size?: "sm" | "md" | "lg";
}> = (props) => {
  return (
    <div
      class={`mr-4 flex items-center justify-center rounded-full`}
      classList={{
        "bg-primary-100 ring-primary-50": props.glowColor === "primary",
        "bg-secondary-100 ring-secondary-50": props.glowColor === "secondary",
        "bg-success-100 ring-success-50": props.glowColor === "success",
        "bg-error-100 ring-error-50": props.glowColor === "error",
        "bg-warning-100 ring-warning-50": props.glowColor === "warning",
        "bg-blue-100 ring-blue-50": props.glowColor === "info",
        "size-8 ring-8": props.size === "sm",
        "size-10 ring-8": !props.size || props.size === "md",
        "size-12 ring-10": props.size === "lg",
      }}
    >
      {props.icon}
    </div>
  );
};
